import { FeatureNotEnabledError } from '../../errors'

// Throwing proxies for opt-in features (oauth / files). When a feature isn't enabled, its slot in the
// handler bag is a proxy that throws on ANY access — so accidental use fails loudly at the call site
// instead of silently no-op'ing or reading `undefined`. See 10-files-api.md and 06-oauth2.md.

export function createThrowingProxy(feature: string, hint: string): Record<string, never> {
  const fail = (): never => {
    throw new FeatureNotEnabledError(feature, hint)
  }

  return new Proxy(
    {},
    {
      get(_target, prop) {
        // Let promise-unwrapping / stringification probe the proxy without throwing.
        if (prop === 'then' || prop === Symbol.toPrimitive || prop === Symbol.toStringTag) {
          return undefined
        }

        return fail()
      },
      apply: fail,
      has: fail,
    }
  ) as Record<string, never>
}
